import * as _ from 'lodash-es'
import { useContext } from 'react'
import { useMutationNext } from '../../componentsF/hooksF/useQueryNextF.js'
import { GameContext } from './GameContextF.jsx'
import { gql } from '@apollo/client'
import { useToastOnError } from '../../componentsF/hooksF/useToastOnErrF.mts'
import { useGameRoom } from './common/GenericGamePage.jsx'

const GameActionMut = gql`
mutation ($gameRoom: String!, $actionJSON: JSON!) {
  gameAction(gameRoom: $gameRoom, actionJSON: $actionJSON)
}`

export const useAction = ({
  onCompleted: _onCompleted=_.noop,
  ...actionJSON
}) => {
  const {gameRoom: _gameRoom, fetchGameUpdate} = useContext(GameContext)
  const {gameRoom} = useGameRoom()

  const variables = {actionJSON, gameRoom}
  const onCompleted = () => {
    if (fetchGameUpdate) fetchGameUpdate()
    else location.reload()
    _onCompleted()
  }
  const [mutateFnc, {loading, data, error}] = useMutationNext(GameActionMut, {variables, onCompleted})

  // prevent double submit
  const doAction = loading ? null : mutateFnc

  useToastOnError({error})

  return {doAction, onClick: doAction, loading, error}
}